module.exports = __webpack_public_path__ + "static/Sonyax56-db2949fd9ab4b7f3b517617a7c17a013.png";